// extracted by mini-css-extract-plugin
module.exports = {"wrap":"bonus_wrap__2YAxS","btn":"bonus_btn__30YcN","content":"bonus_content__2mzDq","link":"bonus_link__3IzjI"};